export const Kind = 'PREVISIT' as const;

export enum Status {
  Created = 'CREATED',
  MessageSent = 'MESSAGE_SENT',
  MessageUndelivered = 'MESSAGE_UNDELIVERED',
  MessageDelivered = 'MESSAGE_DELIVERED',
  CannotReceiveNotification = 'CANNOT_RECEIVE_NOTIFICATION',
  FormStarted = 'FORM_STARTED',
  FormCompleted = 'FORM_COMPLETED',
  FormExpired = 'FORM_EXPIRED',
}
